import React from 'react';
import { StepProps } from '../common/types';


export const AccountInfoTab: React.FC<StepProps> = ({ formik }) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2">
        Daily &amp; Travel Allowance
      </h3>
      <p className="text-sm text-gray-500 -mt-3">
        Leave blank (0) to use the designation-level rates from the Daily Allowance master.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            DA – HQ (₹)
          </label>
          <input
            name='da_hq'
            type="number"
            min={0}
            value={formik.values.da_hq ?? 0}
            onChange={formik.handleChange}
            placeholder="0"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            DA – Ex Station (₹)
          </label>
          <input
            name='da_ex'
            type="number"
            min={0}
            value={formik.values.da_ex ?? 0}
            onChange={formik.handleChange}
            placeholder="0"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            DA – Out Station (₹)
          </label>
          <input
            name='da_out'
            type="number"
            min={0}
            value={formik.values.da_out ?? 0}
            onChange={formik.handleChange}
            placeholder="0"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            TA – Per km (₹)
          </label>
          <input
            name='per_km'
            type="number"
            min={0}
            step="0.01"
            value={formik.values.per_km ?? 0}
            onChange={formik.handleChange}
            placeholder="0.00"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <h3 className="text-lg font-semibold text-gray-900 border-b border-gray-200 pb-2 mt-8">
        Account Information
      </h3>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Account Holder Name
          </label>
          <input
            name='banking_name'
            type="text"
            value={formik.values.banking_name}
            onChange={formik.handleChange}
            placeholder="Enter Account Holder Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Account Number
          </label>
          <input
            name='account_number'
            type="text"
            value={formik.values.account_number}
            onChange={formik.handleChange}
            placeholder="Enter Account Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            IFSC Number
          </label>
          <input
            name='ifsc_code'
            type="text"
            value={formik.values.ifsc_code || ''}
            onChange={formik.handleChange}
            placeholder="Enter IFSC Number"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Beneficiary ID
          </label>
          <input
            name='beneficiary_id'
            type="text"
            value={formik.values.beneficiary_id || ''}
            onChange={formik.handleChange}
            placeholder="Enter Beneficiary ID"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Bank Name
          </label>
          <input
            name='bank_name'
            type="text"
            value={formik.values.bank_name || ''}
            onChange={formik.handleChange}
            placeholder="Enter Bank Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Branch Name
          </label>
          <input
            name='branch_name'
            type="text"
            value={formik.values.branch_name || ''}
            onChange={formik.handleChange}
            placeholder="Enter Branch Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nominee Name
          </label>
          <input
            name='nominee_name'
            type="text"
            value={formik.values.nominee_name || ''}
            onChange={formik.handleChange}
            placeholder="Enter Nominee Name"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Annual Income
          </label>
          <input
            name='annual_income'
            type="number"
            value={formik.values.annual_income || 0}
            onChange={formik.handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>
    </div>
  );
};
